import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useAnalytics } from '../../common/RudderStack';

const UserUnsubscribed: React.FC<{ user: IUser; subscription: ISubscription }> = ({
  subscription,
}) => {
  const history = useHistory();
  const analytics = useAnalytics();

  const settingSubscription = () => {
    analytics?.track('Free Subscription');
    history.push('/settings/subscription');
  };

  return (
    <div className="project-request-box">
      <div className="card p-20" style={{ width: '45%' }}>
        <div className="information-title">
          <img
            className="mt-3"
            src="/Icons/info-subscription.png"
            alt="Informations d’abonnement"
          />
          <h3 className="ml-5" style={{ fontSize: '21px' }}>
            Informations d’abonnement
          </h3>
        </div>
        <p className="pt-3">
          <span style={{ color: '#283549', fontWeight: 'bold', fontSize: '15px' }}>
            Abonnement trimestriel Chantier Privé
          </span>{' '}
          <br />
          <br />
          Abonnement fait le {subscription?.current_period_start}
          <br /> <br />
          Désabonnement fait le {subscription?.current_period_end}
        </p>
      </div>

      <div className="project-request">
        <h2>Renouvelez votre abonnement&#8239;!</h2>

        <p>
          Afin de continuer de bénéficier des services Chantier Privé il vous suffit de cliquer sur
          le bouton <span className="orange">Renouveler mon abonnement</span> ci-dessous. <br /> Si
          vous souhaitez en savoir plus contactez-nous via le numéro{' '}
          <span className="orange"> 0187666076 </span>ou via e-mail à l&lsquo;adresse
          <span className="orange"> contact@chantierprive.fr.</span>.
        </p>
        <div className="col-md-8 mt-4">
          <Link to="#" onClick={() => settingSubscription()} className="btn btn-secondary">
            Renouveler mon abonnement
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UserUnsubscribed;
